/**
 * @license
 * @copyright Copyright Motili Inc., 2017 All Rights Reserved
 */

export const geocoder = new google.maps.Geocoder();

/**
 *
 * @param {String} address
 * @returns {Promise<Object>}
 */
export function geocodeAddress(address) {
    return new Promise((resolve, reject) =>
        geocoder.geocode({ address }, (_results, status) => {
            switch (status) {
                case google.maps.GeocoderStatus.OK: {
                    return resolve(_results[0]);
                }
                case google.maps.GeocoderStatus.ERROR: {
                    const error = new Error(`Unable to locate ${address}`);
                    error.geocoderStatus = google.maps.GeocoderStatus.ERROR;
                    console.log(
                        `Google Maps Geocoder responded with status ${error.geocoderStatus}`
                    );
                    return reject(error);
                }
                case google.maps.GeocoderStatus.INVALID_REQUEST: {
                    const error = new Error(`Unable to locate ${address}`);
                    error.geocoderStatus = google.maps.GeocoderStatus.ERROR;
                    console.log(
                        `Google Maps Geocoder responded with status ${error.geocoderStatus}`
                    );
                    return reject(error);
                }
                case google.maps.GeocoderStatus.OVER_QUERY_LIMIT: {
                    const error = new Error(`Unable to locate ${address}`);
                    error.geocoderStatus = google.maps.GeocoderStatus.ERROR;
                    console.log(
                        `Google Maps Geocoder responded with status ${error.geocoderStatus}`
                    );
                    return reject(error);
                }
                case google.maps.GeocoderStatus.REQUEST_DENIED: {
                    const error = new Error(`Unable to locate ${address}`);
                    error.geocoderStatus = google.maps.GeocoderStatus.ERROR;
                    console.log(
                        `Google Maps Geocoder responded with status ${error.geocoderStatus}`
                    );
                    return reject(error);
                }
                case google.maps.GeocoderStatus.UNKNOWN_ERROR: {
                    const error = new Error(`Unable to locate ${address}`);
                    error.geocoderStatus = google.maps.GeocoderStatus.ERROR;
                    console.log(
                        `Google Maps Geocoder responded with status ${error.geocoderStatus}`
                    );
                    return reject(error);
                }
                case google.maps.GeocoderStatus.ZERO_RESULTS: {
                    const error = new Error(
                        `No results were found for ${address}`
                    );
                    error.geocoderStatus = google.maps.GeocoderStatus.ERROR;
                    console.log(
                        `Google Maps Geocoder responded with status ${error.geocoderStatus}`
                    );
                    return reject(error);
                }
                default: {
                    const error = new Error(`Unable to locate ${address}`);
                    return reject(error);
                }
            }
        })
    );
}
